theme.headerMainMenuModule = (function () {
  function mainMenu() {
    document.querySelectorAll(".header__menu_ul").forEach((nav) => {
      if (nav.dataset.lrMenuReady) return;
      nav.dataset.lrMenuReady = "true";
      const desktop = window.matchMedia("(min-width: 992px)");
      const hover = window.matchMedia("(hover: hover)");
      const items = Array.from(nav.children).filter((item) => item.classList.contains("header__menu_li"));
      let active = null;
      let openTimer;
      let closeTimer;
      const cancel = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      };
      const setOpen = (item, open) => {
        const details = item.querySelector("details");
        const summary = details && details.querySelector("summary");
        if (!summary) return;
        details.open = open;
        summary.setAttribute("aria-expanded", String(open));
      };
      const close = () => {
        cancel();
        items.forEach((item) => setOpen(item, false));
        active = null;
      };
      const open = (item) => {
        cancel();
        if (active === item && item.querySelector("details[open]")) {
          setOpen(item, true);
          return;
        }
        // Open the destination before retiring the previous panel in the same frame.
        setOpen(item, true);
        items.forEach((other) => { if (other !== item) setOpen(other, false); });
        active = item;
      };
      const scheduleClose = () => {
        cancel();
        closeTimer = setTimeout(close, 180);
      };
      items.forEach((item) => {
        const details = item.querySelector("details");
        const summary = details && details.querySelector("summary");
        item.addEventListener("mouseenter", () => {
          if (!desktop.matches || !hover.matches) return;
          cancel();
          if (!summary) return scheduleClose();
          // Ignore brief passes over another category while travelling to its panel.
          openTimer = setTimeout(() => open(item), active ? 70 : 100);
        });
        item.addEventListener("mouseleave", () => {
          if (desktop.matches && hover.matches) scheduleClose();
        });
        if (!summary) return;
        details.addEventListener("toggle", () => {
          summary.setAttribute("aria-expanded", String(details.open));
        });
        let openBeforePointer = false;
        summary.addEventListener("pointerdown", () => { openBeforePointer = details.open; });
        item.addEventListener("focusin", () => {
          if (desktop.matches) open(item);
        });
        item.addEventListener("focusout", () => {
          setTimeout(() => {
            if (!nav.contains(document.activeElement)) close();
          });
        });
        item.addEventListener("keydown", (event) => {
          if (event.key !== "Escape") return;
          event.preventDefault();
          event.stopPropagation();
          summary.focus();
          close();
        });
        summary.addEventListener("click", (event) => {
          if (!desktop.matches) return;
          event.preventDefault();
          event.stopPropagation();
          // A keyboard/touch click opens the menu; a deliberate mouse click follows its collection.
          if (event.detail > 0 && hover.matches && summary.dataset.href) {
            window.location.assign(summary.dataset.href);
          } else if (openBeforePointer && event.detail > 0) {
            close();
          } else {
            open(item);
          }
        });
      });
      nav.addEventListener("mouseenter", cancel);
      nav.addEventListener("mouseleave", () => {
        if (desktop.matches && hover.matches) scheduleClose();
      });
      document.addEventListener("pointerdown", (event) => {
        if (!nav.contains(event.target)) close();
      });
      desktop.addEventListener("change", close);
    });
  }
  return mainMenu;
})();
